// extracted by mini-css-extract-plugin
export default {"item":"menuItem__item-UUJRB","overlay":"menuItem__overlay-oVOix","disabled":"menuItem__disabled-OdQS4"};